module.exports = __webpack_public_path__ + "static/media/button-arrow.06905386.svg";